<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-con">
            <div class="modal-txt">
              <div class="txt-ttl">{{ title }}</div>
              <div class="txt-con">
                <pre v-html="contents"></pre>
              </div>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn" :class="btnClass" @click="close">
                {{ callBackText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue';

const props = defineProps(['data']);
const { title, contents, callBackText } = toRefs(props.data);
const { fnCallBack, btnClass } = props.data;
const emits = defineEmits(['close']);

const close = () => {
  if (fnCallBack) fnCallBack();

  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
